import { useEffect, useRef } from 'react';

/** Reveal-on-scroll: stamps `data-revealed` on the element the first time it
 *  enters the viewport, then disconnects. The paired CSS must keep any hidden
 *  state inside `prefers-reduced-motion: no-preference`, so reduced-motion and
 *  AT users always see the content. */
export function useReveal<T extends HTMLElement>() {
  const ref = useRef<T | null>(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const io = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        el.dataset.revealed = '';
        io.disconnect();
      }
    }, { rootMargin: '0px 0px -10% 0px' });
    io.observe(el);
    return () => io.disconnect();
  }, []);
  return ref;
}
